import React from 'react';

import { Tab, Tabs } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import clsx from 'clsx';

import TabCountBadge from '../tab-count-badge/TabCountBadge';
import { useStyles } from './AppTabs.styles';

export interface TabOptions {
  fullWidth?: boolean;
  /** When true, the tab bar is only as wide as its tabs (e.g. centered on the page). */
  fitContent?: boolean;
}

export interface TabConfigBase {
  label: string;
  value: string;
  itemsCount?: number;
  onboardingKey?: string;
}

export interface IAppTabsBaseProps {
  config: TabConfigBase[];
  options?: TabOptions;
  value: string;
  onChange: (value: string) => void;
  children?: React.ReactNode;
}

const AppTabsBase: React.FC<IAppTabsBaseProps> = ({
  config,
  value,
  onChange,
  children,
  options,
}) => {
  const theme = useTheme();

  const { classes } = useStyles(theme);

  return (
    <div
      className={clsx(
        classes.wrapper,
        options?.fitContent && classes.wrapperFitContent,
      )}>
      <Tabs
        classes={{ root: classes.tabs, scroller: classes.tabsScroller }}
        value={value}>
        {config.map(({ label, value: tabValue, itemsCount, onboardingKey }) => (
          <Tab
            key={tabValue}
            onClick={() => onChange(tabValue)}
            value={tabValue}
            data-onboarding={onboardingKey}
            classes={{
              selected: classes.selectedTab,
              root: clsx(
                classes.tabRoot,
                options?.fullWidth && classes.fullWidthTab,
              ),
            }}
            label={
              <div className={clsx(classes.tab)}>
                <span>{label}</span>
                {typeof itemsCount === 'number' ? (
                  <TabCountBadge
                    count={itemsCount}
                    selected={value === tabValue}
                  />
                ) : null}
              </div>
            }
          />
        ))}
      </Tabs>
      {children}
    </div>
  );
};

export default AppTabsBase;
